Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageFigcaptionReset = exports.imagePictureReset = exports.imageImgReset = void 0;
exports.imageImgReset = {
  ncss: {
    borderStyle: 'none',
    boxSizing: 'border-box',
    display: 'block',
    height: 'auto',
    width: '100%'
  }
};
exports.imagePictureReset = {
  ncss: {
    boxSizing: 'border-box',
    display: 'inline-block'
  }
};
exports.imageFigcaptionReset = {
  ncss: {
    boxSizing: 'border-box',
    fontFamily: 'text'
  }
};